import { siteConfig } from '../../../shared/config/site';
import { scrollToTop } from '../../../shared/lib/scroll';

export function FooterSection() {
  return (
    <footer className="border-t border-neutral-200 bg-bone px-[var(--section-padding-x)] py-12">
      <div className="mx-auto flex max-w-[var(--container-max)] flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <button
            type="button"
            onClick={scrollToTop}
            className="flex min-h-[44px] items-center font-display text-xl font-semibold text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
          >
            {siteConfig.appName}
          </button>
          <p className="mt-3 max-w-sm font-body text-sm leading-6 text-neutral-500">{siteConfig.footerDescription}</p>
        </div>

        <div className="font-body text-sm text-neutral-500">
          <p>{siteConfig.addressLine}</p>
          <p className="mt-2">
            <a
              href={siteConfig.phoneHref}
              className="inline-flex min-h-[44px] items-center text-neutral-700 hover:text-primary-600"
            >
              {siteConfig.phoneDisplay}
            </a>
            {' · '}
            <a
              href={siteConfig.emailHref}
              className="inline-flex min-h-[44px] items-center text-neutral-700 hover:text-primary-600"
            >
              {siteConfig.email}
            </a>
          </p>
          <p className="mt-2">
            {siteConfig.ratingValue} ★ · {siteConfig.reviewCount} reviews
          </p>
        </div>
      </div>
    </footer>
  );
}
